import React from 'react';
import { useTranslation } from 'react-i18next';
import { Briefcase, Building2, HardHat, ArrowRight } from 'lucide-react';
import { motion } from 'framer-motion';

const HowWeHelp: React.FC = () => {
  const { t } = useTranslation();

  const areas = [
    {
      key: 'worker',
      icon: HardHat,
      title: t('practiceAreas.worker.title'),
      desc: t('practiceAreas.worker.shortDescription'),
      cta: t('practiceAreas.worker.cta')
    },
    {
      key: 'corporate',
      icon: Briefcase,
      title: t('practiceAreas.corporate.title'),
      desc: t('practiceAreas.corporate.shortDescription'),
      cta: t('practiceAreas.corporate.cta')
    },
    {
      key: 'condominium',
      icon: Building2,
      title: t('practiceAreas.condominium.title'),
      desc: t('practiceAreas.condominium.shortDescription'),
      cta: t('practiceAreas.condominium.cta')
    }
  ];

  const scrollToServices = () => {
    const element = document.getElementById('areas-de-atuacao');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6
      }
    }
  };

  return (
    <section id="how-we-help" className="section bg-white">
      <div className="wrapper">
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.2 }}
          variants={containerVariants}
          className="text-center mb-16"
        >
          <h2 className="text-3xl md:text-4xl font-heading text-brand-slate mb-6">
            {t('practiceAreas.title')}
          </h2>
          <p className="text-lg text-brand-ink/90 max-w-3xl mx-auto">
            {t('practiceAreas.subtitle')}
          </p>
        </motion.div>

        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.1 }}
          variants={containerVariants}
          className="grid grid-cols-1 md:grid-cols-3 gap-8"
        >
          {areas.map((area) => {
            const Icon = area.icon;
            return (
              <motion.div key={area.key} variants={itemVariants} className="h-full">
                <div className="card card-pad text-center group hover:shadow-xl transition-all duration-300 h-full flex flex-col border border-brand-slate/10">
                  <div className="w-16 h-16 mx-auto mb-6 rounded-xl bg-brand-accent/10 flex items-center justify-center text-brand-accent group-hover:bg-brand-accent group-hover:text-brand-sand transition-colors duration-300">
                    <Icon size={32} />
                  </div>
                  <h3 className="text-2xl font-semibold text-brand-slate mb-4 min-h-[64px] flex items-center justify-center">
                    {area.title}
                  </h3>
                  <p className="text-brand-ink/80 leading-relaxed mb-8 flex-grow">
                    {area.desc}
                  </p>
                  <button 
                    onClick={scrollToServices}
                    className="flex items-center justify-center gap-2 text-brand-accent font-semibold hover:text-brand-slate transition-colors mt-auto py-2"
                  >
                    {area.cta}
                    <ArrowRight size={18} />
                  </button>
                </div>
              </motion.div>
            );
          })}
        </motion.div>
      </div>
    </section>
  );
};

export default HowWeHelp;
